import type { CustomIconProps } from '../types';

const Pencil = ({ width, height }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '18'}
        height={height ?? '18'}
        viewBox="0 0 18 18"
        fill="none"
    >
        <path
            d="M6.5 15L2.96293 16.2862C2.17359 16.5732 1.40346 15.8182 1.67482 15.0233L3 11.1416M6.5 15L15.9378 5.20618C15.9792 5.16321 16.0171 5.11743 16.0471 5.06583C16.3644 4.51953 16.6436 3.28516 15.5 2.1416C13.6153 0.256899 12.6186 1.18431 12.0915 1.57643C12.0315 1.62113 11.974 1.66905 11.9225 1.72341L3 11.1416M6.5 15L3 11.1416M10.7782 2.93128L14.5 6.80827"
            stroke="#414042"
            strokeWidth="2"
        />
    </svg>
);

export default Pencil;
